import {ConnectBasicEntity} from '../../framework/message/ConnectBasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class BaseConnectionParameter extends ConnectBasicEntity {
cnxCode: string;
description: TranslatedEmb;
kind: string;
parameterCode: string;
parameterValue: string;
}

